import { memo } from 'react'

const CheckIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="M20 6 9 17l-5-5"
    />
  </svg>
)

export default memo(CheckIcon)
